import { PageRequest } from '@/core/request/PageRequest';
import { Moment } from 'moment';

export enum EmployeeCommissionSituation {
  AU = 'AU',
  AB = 'AB',
  CA = 'CA',
  FE = 'FE',
}

export const EmployeeCommissionSituations = {
  [EmployeeCommissionSituation.AU]: 'Autorizado',
  [EmployeeCommissionSituation.AB]: 'Aberto',
  [EmployeeCommissionSituation.CA]: 'Cancelado',
  [EmployeeCommissionSituation.FE]: 'Fechado',
};

export interface EmployeeCommission {
  authorizationDate: string;
  baseValue: number;
  closingDate: string;
  codeVersionWorkOrder: string;
  codeWorkOrder: number;
  employeeCommissionId: number;
  employeeId: number;
  commissionValue: number;
  companyId: number;
  consumableUsed: number;
  licensePlate: string;
  nameCustomer: string;
  nameEmployee: string;
  observation: string;
  payDate: string | null;
  percent: number;
  liquidValue: number;
  situation: EmployeeCommissionSituation;
  versionWorkOrder: number;
  workOrderItem: number;
  accountPayableId: number;
  codeAccountPayable: number;
}

export interface EmployeeCommissionListRequest extends PageRequest {
  codeWorkOrder?: number;
  customerName?: string;
  employeeIds?: number[];
  employeeName?: string;
  from?: string;
  licensePlate?: string;
  offset?: number;
  situation?: string;
  to?: string;
  commissionReport?: boolean;
  companyIdFilter?: number;
}

export interface EmployeeCommissionListFormValues
  extends Omit<EmployeeCommissionListRequest, 'from' | 'to'> {
  from?: Moment;
  to?: Moment;
  comissionObservation?: string;
  comissionDate?: string;
  groupByEmployee?: boolean;
  planAccountId?: number;
  documentTypeId?: number;
  value?: number;
  isGenerateAccountsPayable?: boolean;
  isGroupPayableByEmployee?: boolean;
}

export interface EmployeeCommissionCreate {
  companyId: number;
  employeeId: number;
  observation: string;
  payDate: string;
  workOrderItem: number;
  value?: number;
  planAccountId?: number;
  documentTypeId?: number;
}

export interface EmployeeComissionCreateRequest {
  isGenerateAccountsPayable?: boolean;
  isGroupPayableByEmployee?: boolean;
  employeeCommissions: EmployeeCommissionCreate[];
}

export interface EmployeeCommissionCreateResponse {
  companyId: number;
  employeeId: number;
  id: number;
  observation: string;
  payDate: string;
  workOrderItem: number;
}
